// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import http from "@/utils/http";
import Vant from 'vant';
import 'vant/lib/index.css';
import "@/assets/css/common.css"
// import "http://res.wx.qq.com/open/js/jweixin-1.6.0.js";
//
Vue.use(Vant);

Vue.config.productionTip = false
Vue.prototype.$http = http;
Vue.prototype.base_url = http.base_url;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js